// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__8hlul","lastLink":"HeadPage_lastLink__63vZK"};